// inView
const inviewFunc = () => {
  const target = document.querySelectorAll('.js-inview');
  const inViewFunc = () => {
    const scrollY = window.pageYOffset;
    const docH = document.documentElement.scrollHeight;
    const triggerMargin = 80;
    for (let i = 0; i < target.length; i++) {
      if (
        window.innerHeight >
        target[i].getBoundingClientRect().top + triggerMargin
      ) {
        target[i].classList.add('is-view');
      } else {
        target[i].classList.remove('is-view');
      }
      // 最下部へ着いた時
      if (docH < scrollY + 1300) {
        target[i].classList.add('is-view');
      }
    }
  };
  window.addEventListener('scroll', () => {
    inViewFunc();
  });
  setTimeout(function () {
    inViewFunc();
  }, 300);
};

window.addEventListener('DOMContentLoaded', () => {
  inviewFunc();
});
